import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-page-body',
	templateUrl: 'page-body.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class PageBodyComponent {}
